module.exports = __webpack_public_path__ + "static/img/video-11.35332e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/video-11.jpg
// module id = Jyxq
// module chunks = 12